import { isSentOfferFromAdvisor } from "../cartUtils";
import { firstStepUri, productUri } from "./urlUtils";

import { TextManager } from "Components/TextContext";
import { MainPath } from "Constants/constants";
import { Cart } from "Store/cart/cartInterfaces";

export function redirectToLoginPage(): void {
  const { getText } = TextManager;
  const loginPageUrl = getText("url.landingpage.loginpage");
  window.location.assign(
    `${loginPageUrl}?next=${productUri()}/${firstStepUri()}`,
  );
}

export const mustRedirectToOfferAccept = (cart: Cart): boolean =>
  window.location.href.includes(`/${MainPath.OFFER}/`) &&
  isSentOfferFromAdvisor(cart);
